module.exports = "/assets/data/323a1e2678e7d264c6470815e6048f2b-LA10.data.json";